import {
    NinchatActionType,
    NinchatBlockAudienceAddressAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const blockAudienceAddress = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatBlockAudienceAddressAction}`,
    async (arg: NinchatActionParams<NinchatBlockAudienceAddressAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatBlockAudienceAddressAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
